export const NETWORK_ERROR_MESSAGE = 'No internet connection. Please check your network and try again.'
export const TIMEOUT_ERROR_MESSAGE = 'The request timed out. Please check your connection and try again.'

const NETWORK_ERROR_CODES = ['ERR_NETWORK', 'ERR_INTERNET_DISCONNECTED', 'ERR_CONNECTION_REFUSED']
const TIMEOUT_ERROR_CODES = ['ECONNABORTED', 'ETIMEDOUT', 'ERR_CANCELED']

export default class NetworkError extends Error {
  name: string
  type: string
  constructor(message: string = NETWORK_ERROR_MESSAGE) {
    super(message)
    this.name = 'NetworkError'
    this.type = 'network-error'
  }
}

function isOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false
}

/**
 * A request that never reached the backend: the browser is offline, DNS/TCP failed or the
 * request timed out. Such an error carries no `response`, so it must be recognised before
 * any status- or payload-based mapping is attempted.
 */
export function isNetworkError(e: unknown): boolean {
  const error = e as { response?: unknown; code?: string; message?: string }
  if (!error || typeof error !== 'object' || error.response) return false

  const code = error.code ?? ''
  if (NETWORK_ERROR_CODES.includes(code) || TIMEOUT_ERROR_CODES.includes(code)) return true

  return error.message === 'Network Error' || isOffline()
}

export function getNetworkErrorMessage(e: unknown): string {
  const code = (e as { code?: string })?.code ?? ''
  return TIMEOUT_ERROR_CODES.includes(code) && !isOffline() ? TIMEOUT_ERROR_MESSAGE : NETWORK_ERROR_MESSAGE
}
